<template>
  <calm-page
    class="billing-detail"
    :eyebrow="$t('menu.billing')"
    :title="$t('menu.billing')"
  >
    <!-- Page-level back action -->
    <template slot="actions">
      <calm-button
        tag="router-link"
        to="/lmg/billingreport"
        variant="ghost"
        icon="chevron-right"
      >
        {{ $t("back") }}
      </calm-button>
    </template>

    <!-- Due-date hero so the report's period is the first thing the eye lands on -->
    <div class="calm__detail-hero">
      <div>
        <div class="calm__detail-hero__label">{{ $t("menu.billing") }}</div>
        <div class="calm__detail-hero__policy">{{ due_date || "—" }}</div>
      </div>
    </div>

    <!-- Table card: the existing <el-table> is kept verbatim inside <calm-table>
         and auto-skinned by the .calm root that <calm-page> provides. -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('data')"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('lmg.invoice_number')"
    >
      <template slot="toolbar">
        <base-input
          v-model="searchQuery"
          prepend-icon="fas fa-search"
          :placeholder="$t('search')"
        >
        </base-input>
      </template>

      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <el-table-column :label="$t('lmg.invoice_number')" min-width="200">
          <template slot-scope="{ row }">
            {{ row.invoice_number }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.person')" min-width="200">
          <template slot-scope="{ row }">
            {{ row.person_name }} {{ row.person_lname }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.policy_number')" min-width="200">
          <template slot-scope="{ row }">
            {{ row.policy_number }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.amount')" min-width="200">
          <template slot-scope="{ row }">
            {{ FormatCurrency(row.pay_amount) }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.date')" min-width="200">
          <template slot-scope="{ row }">
            {{ row.created_at }}
          </template>
        </el-table-column>
      </el-table>
    </calm-table>
  </calm-page>
  </template>
  <script>
  import { Table, TableColumn, Select, Option } from "element-ui";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
  import { BasePagination } from "@/components";
  import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
  import swal from "sweetalert2";
  import { mapGetters, mapActions } from "vuex";
  import FileInput from "@/components/Inputs/FileInput";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  
  export default {
	mixins: [clientPaginationMixin],
	components: {
	  flatPicker,
	  BasePagination,
	  RouteBreadCrumb,
	  FileInput,
	  [Select.name]: Select,
	  [Option.name]: Option,
	  [Table.name]: Table,
	  [TableColumn.name]: TableColumn
	},
	computed: {
	},
	data() {
	  return {
		propsToSearch: ["invoice_number", "policy_number","person_name","person_lname"],
		selectedRows: [],
		showAddModal: false,
		showImageModal: false,
		showTransactionDetailModal : false,
		tableData:[],
		due_date:"",
	  };
	},
	mounted(){
		// Route params are undefined on a hard refresh / deep-link (no nav state),
		// which would leave the page blank or crash. Degrade gracefully.
		this.tableData = this.$route.params.datas || []
		this.due_date = this.$route.params.due_date || ""
	},
	methods: {
	  selectionChange(selectedRows) {
		this.selectedRows = selectedRows;
	  },
	  filesChange(files) {
		this.md.billfile = files[0];
	  }
	}
  };
  </script>
  <style scoped>
  /* Keep the search input in the table-head toolbar from stretching full width;
     base-input's default block layout would otherwise fill the strip. */
  .billing-detail >>> .calm__table-head__tools .form-group {
	margin-bottom: 0;
	min-width: 240px;
  }
  </style>
  